<template>
  <div
    class="container-fluid menuContainer"
    style="
      display: flex;
      flex-direction: column;
      width: 100%;
      margin: 0px;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      height: fit-content;
      gap: 24px;
      padding: 20px;
    "
  >
    <img
      src="../../src/assets/img/Xtrim/Xtrim-Pro-logo.png"
      class="xtrimproLogo"
    />

    <div
      class="card col-11 col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-5"
      style="padding: 30px; max-width: 800px"
    >
      <div class="text-center mb-2">
        <h1
          class="tips-title"
          style="
            margin-bottom: 15px;
            font-size: 28px;
            line-height: 36px;
            text-align: center;
            font-weight: 700;
            color: #7d0c7e;
          "
        >
          🚀 Tips para ser un Referidor PRO
        </h1>

        <p
          style="
            margin-bottom: 12px;
            font-size: 18px;
            text-align: center;
            color: #666;
            line-height: 26px;
            font-weight: 500;
          "
        >
          Aumenta tus conversiones y maximiza tus ganancias con estos consejos
          probados
        </p>
      </div>

      <div class="tips-container">
        <!-- Tip 1 -->
        <div class="tip-card">
          <div class="tip-icon mobile-hidden">🎯</div>
          <div class="tip-content">
            <h3 class="tip-title">
              <span class="mobile-icon">🎯 </span>Conoce a tu audiencia
            </h3>
            <p class="tip-description">
              Comparte XtrimPro con personas que realmente necesitan internet
              rápido: estudiantes, trabajadores remotos, gamers, y familias con
              múltiples dispositivos.
            </p>
          </div>
        </div>

        <!-- Tip 2 -->
        <div class="tip-card">
          <div class="tip-icon mobile-hidden">💬</div>
          <div class="tip-content">
            <h3 class="tip-title">
              <span class="mobile-icon">💬 </span>Comunica los beneficios, no
              las características
            </h3>
            <p class="tip-description">
              No digas "Internet de 100MB", di "Internet tan rápido que toda tu
              familia puede ver Netflix, YouTube y navegar en redes sociales al
              mismo tiempo sin interrupciones".
            </p>
          </div>
        </div>

        <!-- Tip 3 -->
        <div class="tip-card">
          <div class="tip-icon mobile-hidden">📱</div>
          <div class="tip-content">
            <h3 class="tip-title">
              <span class="mobile-icon">📱 </span>Usa WhatsApp y redes sociales
            </h3>
            <p class="tip-description">
              Comparte tu enlace en estados de WhatsApp, historias de Instagram,
              y grupos familiares. La comunicación personal convierte mejor.
            </p>
          </div>
        </div>

        <!-- Tip 4 -->
        <div class="tip-card">
          <div class="tip-icon mobile-hidden">⏰</div>
          <div class="tip-content">
            <h3 class="tip-title">
              <span class="mobile-icon">⏰ </span>Busca el momento perfecto
            </h3>
            <p class="tip-description">
              Los mejores momentos para contactar suelen ser en las mañanas
              (9-11am) y luego del horario laboral (6-9pm).
            </p>
          </div>
        </div>

        <!-- Tip 5 -->
        <div class="tip-card">
          <div class="tip-icon mobile-hidden">🔥</div>
          <div class="tip-content">
            <h3 class="tip-title">
              <span class="mobile-icon">🔥 </span>Crea urgencia responsable
            </h3>
            <p class="tip-description">
              "Solo por este mes hay descuentos especiales" o "Las instalaciones
              están llenándose rápido en tu zona". Pero siempre sé honesto.
            </p>
          </div>
        </div>

        <!-- Tip 6 -->
        <div class="tip-card">
          <div class="tip-icon mobile-hidden">🤝</div>
          <div class="tip-content">
            <h3 class="tip-title">
              <span class="mobile-icon">🤝 </span>Seguimiento personal
            </h3>
            <p class="tip-description">
              Después de compartir tu enlace, pregunta en 2-3 días: "¿Pudiste
              revisar la propuesta de internet? ¿Tienes alguna duda?". El
              seguimiento es clave.
            </p>
          </div>
        </div>

        <!-- Tip 7 -->
        <div class="tip-card">
          <div class="tip-icon mobile-hidden">💰</div>
          <div class="tip-content">
            <h3 class="tip-title">
              <span class="mobile-icon">💰 </span>Comparte tu éxito
            </h3>
            <p class="tip-description">
              Cuando ganes tus primeros $20, ¡compártelo! Nada convence más que
              ver resultados reales. Toma capturas de tus ganancias (sin datos
              sensibles).
            </p>
          </div>
        </div>

        <!-- Tip 8 -->
        <div class="tip-card">
          <div class="tip-icon mobile-hidden">📊</div>
          <div class="tip-content">
            <h3 class="tip-title">
              <span class="mobile-icon">📊 </span>Analiza y mejora
            </h3>
            <p class="tip-description">
              Revisa qué mensajes funcionan mejor, en qué grupos tienes más
              éxito, y ajusta tu estrategia. La mejora continua es la clave del
              éxito.
            </p>
          </div>
        </div>
      </div>

      <!-- Call to Action -->
      <div class="cta-section text-center mt-4">
        <div class="success-badge">
          💡 <strong>Tip PRO:</strong> Los mejores referidores combinan estos
          consejos y son constantes
        </div>

        <button
          @click="goToDashboard"
          class="btn btn-yellow-normal mt-3"
          style="font-size: 16px; padding: 12px 30px"
        >
          ¡Volver al Dashboard y Aplicar Tips! 🚀
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tips",
  data() {
    return {};
  },
  mounted() {
    document.title = "XtrimPro - Tips para Referidores";
  },
  methods: {
    goToDashboard() {
      this.$router.push("/dashboard");
    },
  },
};
</script>

<style scoped>
.container-fluid {
  padding: 0px;
  margin: 0px;
}

.xtrimproLogo {
  max-width: 300px;
  width: auto;
  margin-bottom: 20px;
}

@media (max-width: 480px) {
  .xtrimproLogo {
    max-width: 200px;
    margin-bottom: 0;
  }
}

.menuContainer {
  display: flex;
  min-height: 100vh;
  height: 100%;
  justify-content: center;
  align-items: center;
  min-height: calc(var(--vh, 1vh) * 100);
  margin: 0px;
  padding: 0;
  background-color: #7d0c7e !important;
  background: url("../../src/assets/img/Xtrim/register-background.png")
    no-repeat center center;
  background-size: cover;
}

.card {
  border-radius: 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  border: none;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(15px);
}

.tips-title {
  font-family: "Ubuntu", sans-serif;
  background: linear-gradient(45deg, #7d0c7e, #a532bd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.tips-container {
  display: grid;
  gap: 20px;
}

.tip-card {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 20px;
  border-radius: 16px;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%);
  border: 2px solid rgba(125, 12, 126, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.tip-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #7d0c7e, #a532bd);
  transition: width 0.3s ease;
}

.tip-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(125, 12, 126, 0.15);
  border-color: rgba(125, 12, 126, 0.3);
}

.tip-card:hover::before {
  width: 100%;
  opacity: 0.05;
}

.tip-icon {
  font-size: 32px;
  min-width: 50px;
  text-align: center;
  line-height: 1;
}

.tip-content {
  flex: 1;
}

.tip-title {
  font-size: 18px;
  font-weight: 700;
  color: #7d0c7e;
  margin-bottom: 8px;
  font-family: "Ubuntu", sans-serif;
}

.tip-description {
  font-size: 15px;
  color: #444;
  line-height: 1.6;
  margin: 0;
}

.btn-yellow-normal {
  background: linear-gradient(45deg, #f9cc03, #ffd700);
  border: none;
  color: #7d0c7e;
  font-weight: 700;
  border-radius: 12px;
  padding: 12px 24px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(249, 204, 3, 0.3);
}

.btn-yellow-normal:hover {
  background: linear-gradient(45deg, #e6b800, #f9cc03);
  color: #7d0c7e;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(249, 204, 3, 0.4);
}

.cta-section {
  margin-top: 30px;
  padding-top: 25px;
  border-top: 2px solid rgba(125, 12, 126, 0.1);
}

.success-badge {
  display: inline-block;
  padding: 12px 20px;
  background: linear-gradient(135deg, #e8f5e8, #d4edda);
  border: 2px solid #28a745;
  border-radius: 12px;
  color: #155724;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 15px;
}

/* Mobile icon handling */
.mobile-icon {
  display: none;
}

.mobile-hidden {
  display: block;
}

/* Responsive Design */
@media (max-width: 768px) {
  .tips-title {
    font-size: 24px;
    line-height: 30px;
  }

  .tip-card {
    padding: 15px;
    gap: 12px;
  }

  .tip-icon {
    font-size: 28px;
    min-width: 40px;
  }

  .tip-title {
    font-size: 16px;
  }

  .tip-description {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .card {
    margin: 10px;
    padding: 20px !important;
  }

  .tips-title {
    font-size: 22px;
  }

  .tip-card {
    flex-direction: column;
    text-align: left;
    gap: 0;
    padding: 15px;
  }

  /* Hide separate emoji icons on mobile */
  .mobile-hidden {
    display: none;
  }

  /* Show emoji icons inline with titles on mobile */
  .mobile-icon {
    display: inline;
    font-size: 18px;
  }

  .tip-title {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .tip-description {
    font-size: 14px;
  }
}
</style>
